module.exports = __webpack_public_path__ + "img/flower.785ad469.webp";